import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-activity-goto-resolver',
  templateUrl: './activity-goto-resolver.component.html',
  styleUrl: './activity-goto-resolver.component.scss'
})
export class ActivityGotoResolverComponent implements OnInit{
  constructor(private route: ActivatedRoute,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router) {}

  ngOnInit(): void {
    this.fuseSplashScreenService.show();
    this.route.queryParamMap.subscribe(params => {
      const activityId = params.get('activityId');
        this.goToPage(activityId);
    });
  }

  private goToPage(activityId: string) {
    const command = new PlatformCommand('NavigateToActivityLandingPageCommand', 'CollaborationApi');
    command.fieldValues['MessageId'] = activityId;
    command.fieldValues['Source'] = 'email';
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        } else if (response.fieldValues['ErrorMessage']) {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError(response.fieldValues['ErrorMessage']);
        }
      }
      this.fuseSplashScreenService.hide();
    });
  }
}
